import { render, staticRenderFns } from "./ContentXmlView.vue?vue&type=template&id=dc1d7f3a"
import script from "./ContentXmlView.vue?vue&type=script&lang=js"
export * from "./ContentXmlView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports